import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  onAuthStateChanged,
  type Auth as FirebaseAuth,
  type User,
} from 'firebase/auth';

export {
  applyActionCode,
  checkActionCode,
  confirmPasswordReset,
  connectAuthEmulator,
  createUserWithEmailAndPassword,
  EmailAuthProvider,
  getAuth,
  GoogleAuthProvider,
  reauthenticateWithCredential,
  reauthenticateWithPopup,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updatePassword,
  verifyBeforeUpdateEmail,
  verifyPasswordResetCode,
} from 'firebase/auth';
export type { User } from 'firebase/auth';

/** Firebase Auth for the default app; injectable and usable as a type. */
export const Auth = new InjectionToken<FirebaseAuth>('FirebaseAuth');
export type Auth = FirebaseAuth;

/** Emits the signed-in user (or null) now and on every sign-in/sign-out. */
export function authState(auth: Auth): Observable<User | null> {
  return new Observable<User | null>(subscriber =>
    onAuthStateChanged(
      auth,
      user => subscriber.next(user),
      error => subscriber.error(error)
    )
  );
}
